import { render, staticRenderFns } from "./MatchHistory.vue?vue&type=template&id=a5a2df3a&scoped=true&"
import script from "./MatchHistory.vue?vue&type=script&lang=js&"
export * from "./MatchHistory.vue?vue&type=script&lang=js&"
import style0 from "./MatchHistory.vue?vue&type=style&index=0&id=a5a2df3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a2df3a",
  null
  
)

export default component.exports